<template>
  <v-list-item
    dense
    :value="assetField"
    active-class="deep-green--text text--accent-4"
    :class="{
      'editing-container': assetField.isEditing,
      'asset-field-list-item': !assetField.isEditing,
    }"
  >
    <template v-slot:default="{}">
      <v-list-item-content class="pa-0 ma-0">
        <div v-if="assetField.isEditing">
          <v-row dense class="pb-0">
            <v-col cols="12" class="pb-0">
              <v-text-field
                v-model="assetField.title"
                placeholder="Enter a custom field title"
                size="50"
                hide-details
                class="mb-2"
              />
            </v-col>
          </v-row>
        </div>
        <div v-if="!assetField.isEditing">
          <div class="ml-1 mt-2 text-subtitle-1">{{ assetField.title }}</div>
        </div>
      </v-list-item-content>

      <div class="mt-2">
        <div class="pull-left">
          <v-icon
            small
            class="mr-3 mt-4"
            v-if="!assetField.isEditing"
            v-on:click.prevent="handleClickEdit"
            >mdi-pencil</v-icon
          >
        </div>

        <v-switch
          v-model="assetField.enabled"
          class="pull-left pa-0 ma-0 mt-3"
          solo
          v-if="!assetField.isEditing"
          v-on:change="handleClickSave"
          :disabled="assetField.isDraft"
        ></v-switch>
        <div class="pull-right ml-3" v-if="assetField.isEditing">
          <v-btn
            small
            class="btn primary"
            :disabled="loadingSave"
            @click.prevent="handleClickSave"
          >
            <Loader
              v-if="loadingSave"
              size="small"
              color="white"
              text=""
              class="pull-right mr-2"
            ></Loader>
            Save
          </v-btn>
          <v-btn
            text
            color="primary"
            small
            class="btn ml-2"
            @click.prevent="handleClickCancel"
          >
            Cancel
          </v-btn>
        </div>
        <div class="clearfix"></div>
      </div>
    </template>
  </v-list-item>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";

import { MODULE_PREFIX_ASSETS } from "@/store";
import {
  SAVE_ASSET_CUSTOM_FIELDS,
  GET_ASSETS_REFRESH_MAP,
} from "@/store/actions.type";

const EMITTED_ACTIONS = {
  EDIT: "edit",
  SAVE: "save",
  CANCEL: "cancel",
};

export default {
  name: "AssetsCustomFieldEditor",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    assetField: {
      type: Object,
    },
  },
  data() {
    return {
      originalAssetField: null,
      loadingSave: false,
    };
  },
  computed: {},
  methods: {
    handleClickEdit() {
      this.$emit(EMITTED_ACTIONS.EDIT, this.assetField);
      this.originalAssetField = lodashCloneDeep(this.assetField);
    },
    async handleClickSave() {
      this.loadingSave = true;
      const assetField = lodashCloneDeep(this.assetField);
      assetField.title = assetField.title.trim();
      await this.$store.dispatch(
        MODULE_PREFIX_ASSETS + SAVE_ASSET_CUSTOM_FIELDS,
        assetField
      );
      // This does reload asset on map without any filters
      this.$store.dispatch(
        MODULE_PREFIX_ASSETS + GET_ASSETS_REFRESH_MAP,
        new Date().toISOString()
      );
      this.originalAssetField = null;
      this.$emit(EMITTED_ACTIONS.SAVE);
      this.loadingSave = false;
    },
    handleClickCancel() {
      this.$emit(EMITTED_ACTIONS.CANCEL, this.assetField);
    },
  },
};
</script>

<style>
.v-list-item.asset-field-list-item {
  height: 52px !important;
}
</style>
<style scoped>
.asset-field-title {
  position: relative;
  margin-top: 4px;
}
.color-holder {
  height: 24px;
  width: 24px;
  border-radius: 12px;
}
.editing-container {
  background-color: #f0f0f0 !important;
}
</style>
